/**
 * Created by cc on 2016/10/20 0020.
 */
module.exports = {
    '/flow/show.html':{title: '进入流程处理界面', type: false, path: 'FlowController.showFlow'},
    '/flow/do.html':{title: '处理流程', type: false, path: 'FlowController.doFlow'}
};